export default __webpack_public_path__ + "static/media/1759.a93d5c71.png";